import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API_BASE } from './apiBase';

const FORMAT_RE = /^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/;

/**
 * Live-E-Mail-Prüfung (debounced): Format, Tippfehler-Vorschlag, Domain-Existenz (Backend MX-Check).
 * status: 'empty' | 'checking' | 'ok' | 'typo' | 'invalid'
 */
export function useEmailCheck(email) {
  const [result, setResult] = useState({ status: 'empty', suggestion: null, message: null });
  const timer = useRef(null);
  const seq = useRef(0);

  useEffect(() => {
    const e = (email || '').trim();
    clearTimeout(timer.current);
    if (!e) {
      setResult({ status: 'empty', suggestion: null, message: null });
      return;
    }
    if (!FORMAT_RE.test(e)) {
      // Formatfehler übernimmt die bestehende Feld-Validierung – hier kein Netz-Call
      setResult({ status: 'empty', suggestion: null, message: null });
      return;
    }
    setResult((r) => ({ ...r, status: 'checking' }));
    const mySeq = ++seq.current;
    timer.current = setTimeout(async () => {
      try {
        const r = await axios.post(`${API_BASE}/api/email/check`, { email: e }, { timeout: 6000 });
        if (mySeq !== seq.current) return;
        const d = r.data || {};
        if (d.blocked) {
          setResult({ status: 'invalid', suggestion: d.suggestion || null, message: d.message });
        } else if (d.suggestion) {
          setResult({ status: 'typo', suggestion: d.suggestion, message: null });
        } else {
          setResult({ status: 'ok', suggestion: null, message: null });
        }
      } catch {
        if (mySeq === seq.current) setResult({ status: 'ok', suggestion: null, message: null });
      }
    }, 600);
    return () => clearTimeout(timer.current);
  }, [email]);

  return result;
}
